<h5 class="text-primary mb-3">Blinds and curtains</h5>
<div class="window">
  <div class="center">
    <div class="shadow bg-primary"></div>
    <div class="blind border-primary"
         [style.height]="blindPosition() + '%'"></div>
    <div class="curtain border-primary"
         [style.height]="curtainPosition() + '%'"></div>
  </div>
</div>